/**
 * المرحلة 1.4 — the reason a closed visit is changed.
 *
 * The server keeps every change after closing as an amendment, with who made
 * it, when and why, and prints them under the report; it refuses one with no
 * reason (AMEND_REASON, at least three letters). This asks before the write
 * is sent, so the doctor never meets the refusal.
 */

import { useEffect, useState } from 'react';
import { Button, Field, Modal, Textarea } from '../../components/common';
import { useI18n } from '../../i18n/I18nProvider';

export const REASON_MIN = 3;
export const REASON_MAX = 300;

export function ReasonDialog({ open, what, onCancel, onConfirm }) {
  const { t } = useI18n();
  const [text, setText] = useState('');
  useEffect(() => {
    if (open) setText('');
  }, [open]);
  const clean = text.trim();
  const ok = clean.length >= REASON_MIN;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={t('encounter.reason.title')}
      icon="history"
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button icon="check" disabled={!ok} onClick={() => onConfirm(clean.slice(0, REASON_MAX))} data-testid="reason-confirm">
            {t('encounter.reason.confirm')}
          </Button>
        </div>
      }
    >
      <p className="mb-3 text-sm leading-relaxed text-slate-300">
        {what ? t('encounter.reason.textWhat', { what }) : t('encounter.reason.text')}
      </p>
      <Field label={t('encounter.reason.label')} hint={t('encounter.reason.hint')}>
        <Textarea
          rows={3}
          value={text}
          maxLength={REASON_MAX}
          onChange={(e) => setText(e.target.value)}
          placeholder={t('encounter.reason.placeholder')}
          data-testid="reason-text"
          autoFocus
        />
      </Field>
    </Modal>
  );
}

export default ReasonDialog;
